import { Draft, produce } from 'immer'
import { queryClient } from '../../../api/query-client'
import { mergeKeyWith } from '../../../common/query'

export { arkivinfoKeys, arkivinfoQueryHelpers }

export const getArkivinfoKeys = () => {
  const keys = {
    all: [{ entity: 'arkivinfo' }] as const,
    get: (kvitteringId: string) => mergeKeyWith(keys.all, { kvitteringId }),
    updateSkjermetOrd: () =>
      mergeKeyWith(keys.all, { action: 'update-skjermet-ord' }),
  }

  return keys
}

const arkivinfoKeys = getArkivinfoKeys()

export type ArkivinfoKeys = typeof arkivinfoKeys

const arkivinfoQueryHelpers = {
  invalidate: (kvitteringId: string) =>
    queryClient.invalidateQueries({
      queryKey: arkivinfoKeys.get(kvitteringId),
    }),
  updateCache: (
    kvitteringId: string,
    updater: (draft: Draft<ITilsynskvitteringRemote.ArkivInfoRes>) => void
  ) => {
    queryClient.setQueryData<ITilsynskvitteringRemote.ArkivInfoRes>(
      arkivinfoKeys.get(kvitteringId),
      (cache) => {
        if (!cache) return cache

        return produce(cache, (draft) => updater(draft))
      }
    )
  },
}
